import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Alert from "@mui/material/Alert";
// Router
import { Link, useNavigate } from "react-router-dom";
// Image
import tvc_Logo from "../photos/tvc_logo.png";

import loginCover from "../photos/login_cover.jpg";

export default function ForgotPass() {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [user, setUser] = useState({ user_email: "" });
  const [isSuccess, setisSuccess] = useState();

  const [message, setMessage] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate for redirect

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user.user_email || !user.user_email.includes("@")) {
      setMessage("Please enter a valid email.");
      setisSuccess(false);
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/sendEmail`, {
        user_email: user.user_email,
      });

      setMessage(response.data.message);
      setisSuccess(true);
    } catch (error) {
      setisSuccess(false);
      if (error.response?.data?.error) {
        setMessage(error.response.data.error);
      } else {
        setMessage("Failed to send email. Please try again.");
      }
    }
  };

  const handleClick = () => {
    navigate("/");
  };

  return (
    <Box
      component="form"
      sx={{
        "& > :not(style)": { m: 1, width: "55ch" },
      }}
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      width={"100%"}
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <img
        src={tvc_Logo}
        alt="The Vintage Collective"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      />
      {message == "" ? (
        ""
      ) : (
        <Alert severity={isSuccess ? "success" : "error"}>{message}</Alert>
      )}
      <TextField
        id="outlined-basic"
        label="Email"
        variant="outlined"
        value={user.user_email}
        onChange={(event) => {
          setUser({ ...user, user_email: event.target.value });
        }}
      />

      <Button variant="contained" type="Submit">
        Send Link to Email
      </Button>
      <span>
        Are you new here? <Link to={"/register"}>Sign up here!</Link>
      </span>
    </Box>
  );
}
